import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { AuthenticationService } from 'src/app/_services'
import { environment } from 'src/environments/environment'
import * as XLSX from 'xlsx'
@Component({
  selector: 'app-report-product-receiverid',
  templateUrl: './report-product-receiverid.component.html',
  styleUrls: ['./report-product-receiverid.component.css']
})
export class ReportProductReceiveridComponent implements OnInit {
  reportProductsReceiverId = []
  label = ''

  onNoClick (): void {
    this.dialogRef.close()
  }
  constructor (
    public dialogRef: MatDialogRef<ReportProductReceiveridComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authenticationService: AuthenticationService,
    public http: HttpClient
  ) {
    this.reportProductsReceiverId = []
  }

  ngOnInit (): void {}
  OnSelectLocations (productId: any) {
    this.http
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/reportProductsReceiverId?productId=${Number(
          productId
        )}&CompanyId=${Number(
          this.authenticationService.currentUserValue.companyIdWh
        )}&CompledReceiver=1`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.reportProductsReceiverId = response

        try {
          if (this.reportProductsReceiverId.length > 0) {
            this.label = 'processing data'
            this.exportAsExcel()
          } else {
            this.label = 'no data'
          }
        } catch (error) {}
      })
  }
  exportAsExcel () {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      this.reportProductsReceiverId
    ) //converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new()
    ws['!cols'] = [
      { wch: 10 },
      { wch: 20 },
      { wch: 25 },
      { wch: 25 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 10 },
      { wch: 10 },
      { wch: 10 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 20 },
      { wch: 20 }
    ]
    XLSX.utils.sheet_add_aoa(
      ws,
      [
        [
          'RECEIVERITEMS#',
          'RECEIVER#',
          'ITEMNUMBER',
          'DESCRIPTION',
          'RECEIVER-QUANTITY',
          'DISCREPANCY-QUANTITY',
          'AVAILABLE-QUANTITY',
          'UNIT-TYPE',
          'WEIGHT',
          'PALLET',
          'LOCATION',
          'NOTE',
          'COMPLETED',
          'COMPLETED-DATE',
          'CREATED-DATE'

        ]
      ],
      { origin: 'A1' }
    )
    XLSX.utils.book_append_sheet(wb, ws, 'SheetProduct')

    /* save to file */
    XLSX.writeFile(wb, 'SheetProduct.xlsx')
  }
}
